import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { checkUserAuthorization } from "../helpers/checkUserAuthorization";

const ProtectedRoute = ({
  children,
  requiredRole,
  requiredRoles,
}: {
  children: React.ReactNode;
  requiredRole?: string;
  requiredRoles?: string[];
}) => {
  const { token } = useAuth();

  if (!token) {
    return <Navigate to="/login" />;
  }

  const rolesToCheck = requiredRoles ?? (requiredRole ? [requiredRole] : []);

  if (!rolesToCheck.length) {
    return <>{children}</>;
  }

  const isAuthorized = rolesToCheck.some((role) =>
    checkUserAuthorization(token, role),
  );

  if (!isAuthorized) {
    return <Navigate to="/unauthorized" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
